<script setup lang="ts">
import { cn } from '@/utils/cn'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
  title?: string
  class?: string
}>(), { title: undefined, class: undefined })
</script>

<template>
  <div
    :class="
      cn(
        'w-full max-w-full min-w-0 gap-0 overflow-hidden rounded-2xl border border-gray-200 bg-white p-0 sm:p-0 dark:border-gray-800 dark:bg-white/3',
        props.class,
      )
    "
  >
    <header v-if="props.title || $slots.controls" class="flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <div v-if="props.title">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
          <slot name="title">{{ props.title }}</slot>
        </h3>
      </div>

      <div v-if="$slots.controls" class="flex items-center gap-3 w-full sm:w-auto">
        <slot name="controls" />
      </div>
    </header>

    <div class="max-w-full overflow-x-auto min-w-0">
      <slot />
    </div>

    <footer v-if="$slots.footer" class="border-t-0 px-4 py-4 sm:px-6">
      <slot name="footer" />
    </footer>
  </div>
</template>
